 


import type { RouteObject } from 'react-router';
import { lazyRoute } from '../utils/lazyRoute';

const reportsRoutes: RouteObject[] = [
  {
    path: 'RPT/HomePage',
    lazy: lazyRoute(() => import('../../pages/NTX/Reports/Report/Index/Index'))
  },

  // Dashboard Management
  {
    path: 'RPT/NtxDashboardManagement',
    lazy: lazyRoute(() => import('../../pages/NTX/DashboardManagament/index/Index'))
  },
  {
    path: 'RPT/NtxDashboardManagement/AddUpdate',
    lazy: lazyRoute(() => import('../../pages/NTX/DashboardManagament/AddDashboard/Add'))
  },
  {
    path: 'RPT/NtxDashboardManagement/:DashboardId/UpdateDashBoard',
    lazy: lazyRoute(() => import('../../pages/NTX/DashboardManagament/UpdateDashBoard/Update'))
  },

  // Reports
  {
    path: 'RPT/Reports/*',
    children: [
      { path: '*', lazy: lazyRoute(() => import('../../pages/NTX/Reports/Report/Index/Index')) },
      { path: 'AddReport', lazy: lazyRoute(() => import('../../pages/NTX/Reports/Report/Add/AddReport')) },
      { path: ':id/UpdateReport', lazy: lazyRoute(() => import('../../pages/NTX/Reports/Report/Update/UpdateReport')) },
      { path: ':id/AddReportShape', lazy: lazyRoute(() => import('../../pages/NTX/Reports/ReportChart/Add/AddReportShape')) }
    ]
  },

  // Printing Forms
  {
    path: 'RPT/PrintingForms/*',
    children: [
      { path: '*', lazy: lazyRoute(() => import('../../pages/NTX/Reports/PrintingForms/Index/Index')) },
      { path: 'AddPrintingForms', lazy: lazyRoute(() => import('../../pages/NTX/Reports/PrintingForms/Add/AddPrintingForms')) },
      { path: ':id/UpdatePrintingForms', lazy: lazyRoute(() => import('../../pages/NTX/Reports/PrintingForms/Update/UpdatePrintingForms')) },
      { path: 'Notes', lazy: lazyRoute(() => import('../../pages/NTX/Reports/PrintingForms/Notes')) }
    ]
  },

  // ~~ Printing Forms Letter ~~
  {
    path: 'RPT/PrintingFormsLetter',
    lazy: lazyRoute(() => import('../../pages/NTX/Reports/PrintingFormsLetter/Index'))
  },
  {
    path: 'RPT/PrintingFormsLetter/:FormId/AddPrintingFormsLetter',
    lazy: lazyRoute(() => import('../../pages/NTX/Reports/PrintingFormsLetter/Add/AddLettersForms.jsx'))
  },
  {
    path: 'RPT/PrintingFormsLetter/:printTemplateId/UpdatePrintingFormsLetter',
    lazy: lazyRoute(() => import('../../pages/NTX/Reports/PrintingFormsLetter/Update/UpdateLettersForms.jsx'))
  }
];

export default reportsRoutes;

